module.exports = __webpack_public_path__ + "static/img/icon-back.dfd17bde.svg";